/* ============================================================
   Video Reviews Slider — av-video-reviews.js
   Save to: Assets/av-video-reviews.js

   Handles:
     - Horizontal scroll navigation via arrows
     - Auto show/hide arrows when content overflows
     - Lazy-load + autoplay muted in-feed videos
   Videos are display-only: NO lightbox, NO audio, not clickable
   (owner decision 2026-07-02 — lightbox code removed).
   ============================================================ */

(function () {
  'use strict';

  function initCarousel(carousel) {
    const trackWrap = carousel.querySelector('.av-vr__track-wrap');
    const track = carousel.querySelector('.av-vr__track');
    if (!trackWrap || !track) return;

    const section = carousel.closest('.av-vr');
    const prevBtn = section.querySelector(`.av-vr__arrow--prev[data-vr-target="${carousel.id}"]`);
    const nextBtn = section.querySelector(`.av-vr__arrow--next[data-vr-target="${carousel.id}"]`);

    function updateArrows() {
      if (!prevBtn && !nextBtn) return;
      const needsScroll = trackWrap.scrollWidth > trackWrap.clientWidth + 2;
      if (prevBtn) prevBtn.style.display = needsScroll ? 'flex' : 'none';
      if (nextBtn) nextBtn.style.display = needsScroll ? 'flex' : 'none';
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const step = Math.round(trackWrap.clientWidth * 0.8);
        trackWrap.scrollBy({ left: -step, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const step = Math.round(trackWrap.clientWidth * 0.8);
        trackWrap.scrollBy({ left: step, behavior: 'smooth' });
      });
    }

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateArrows, 120);
    });

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => updateArrows());
      ro.observe(track);
    }

    updateArrows();
    setTimeout(updateArrows, 300);
  }

  /* Lazy-load in-feed videos: attach src + play only when scrolled near the
     viewport, pause when out of view. With autoplay off, in-feed videos never
     load (the poster stands in). */
  function playInView(v) {
    if (!v.src && v.dataset.vrVideoSrc) {
      v.src = v.dataset.vrVideoSrc;
      v.load();
    }
    const p = v.play();
    if (p !== undefined) p.catch(() => {});
  }
  function initLazyVideos() {
    const vids = document.querySelectorAll('.av-vr__video[data-vr-video-src]');
    if (!vids.length) return;
    const isAutoplay = (v) => {
      const car = v.closest('.av-vr__carousel');
      return car && car.dataset.vrAutoplay === 'true';
    };
    if (typeof IntersectionObserver === 'undefined') {
      vids.forEach(v => { if (isAutoplay(v)) playInView(v); });
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const v = entry.target;
        if (entry.isIntersecting) {
          if (isAutoplay(v)) playInView(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '300px 0px', threshold: 0.1 });
    vids.forEach(v => io.observe(v));
  }

  function init() {
    const carousels = document.querySelectorAll('.av-vr__carousel');
    carousels.forEach(initCarousel);
    initLazyVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
